var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

export function getSchemaType(schema) {
    var type = schema.type;


    if (!type && schema.const) {
        return guessType(schema.const);
    }

    if (!type && schema.enum) {
        return "string";
    }

    if (type instanceof Array && type.length === 2 && type.includes("null")) {
        return type.find(function (type) {
            return type !== "null";
        });
    }

    return type;
}

// In the case where we have to implicitly create a schema, it is useful to know what type to use
//  based on the data we are defining
export var guessType = function guessType(value) {
    if (Array.isArray(value)) {
        return "array";
    } else if (typeof value === "string") {
        return "string";
    } else if (value == null) {
        return "null";
    } else if (typeof value === "boolean") {
        return "boolean";
    } else if (!isNaN(value)) {
        return "number";
    } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
        return "object";
    }
    // Default to string if we can't figure it out
    return "string";
};